// Detail Modal for Parameter Selection
import React, { useState, useEffect } from 'react';
import './param-detail-modal.css';

function ParamDetailModal({ 
  isOpen, 
  onClose, 
  data, 
  mode, 
  onSave, 
  fieldToEdit,
  patientId
}) {
  const [editedData, setEditedData] = useState({});
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (data && isOpen) {
      setEditedData({...data});
    }
  }, [data, isOpen]);
  
  const handleInputChange = (field, value) => {
    setEditedData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  
  const handleSave = async () => {
    setLoading(true);
    try {
      await onSave(patientId, editedData);
      onClose();
    } catch (error) {
      console.error('Error saving data:', error);
      alert('Failed to save changes. Please try again.');
    }
    setLoading(false);
  };
  
  if (!isOpen || !data) return null;
  
  return (
    <div className="param-modal-overlay" onClick={onClose}>
      <div className="param-modal" onClick={e => e.stopPropagation()}>
        <div className="param-modal-header">
          <h3>
            {mode === 'view' ? 'View Details' : 'Edit Field'}
            {mode === 'edit' && fieldToEdit && <span> - {fieldToEdit}</span>}
          </h3>
          <button className="param-modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="param-modal-content">
          {mode === 'view' ? (
            // View mode shows all fields
            <div className="param-modal-fields">
              {Object.entries(data).filter(([key]) => key !== 'trial_biomarker_info').map(([key, value]) => (
                <div className="param-modal-field-row" key={key}>
                  <div className="param-modal-field-label">{key}:</div>
                  <div className="param-modal-field-value">{value !== null ? String(value) : 'N/A'}</div>
                </div>
              ))}
              
              {data.trial_biomarker_info && (
                <>
                  <div className="param-modal-section">Trial Information</div>
                  {Object.entries(data.trial_biomarker_info).map(([key, value]) => (
                    <div className="param-modal-field-row" key={key}>
                      <div className="param-modal-field-label">{key}:</div>
                      <div className="param-modal-field-value">{value !== null ? String(value) : 'N/A'}</div>
                    </div>
                  ))}
                </>
              )}
            </div>
          ) : (
            // Edit mode shows only the field being edited
            <div className="param-modal-edit">
              <label className="param-modal-edit-label">
                {fieldToEdit}:
                {fieldToEdit === 'tier' ? (
                  <select 
                    value={editedData[fieldToEdit] || ''}
                    onChange={e => handleInputChange(fieldToEdit, e.target.value)}
                    className="param-modal-input"
                  >
                    <option value="1">Tier 1</option>
                    <option value="3">Tier 3</option>
                    <option value="4">Tier 4</option>
                  </select>
                ) : (
                  <input 
                    type="text" 
                    value={editedData[fieldToEdit] || ''}
                    onChange={e => handleInputChange(fieldToEdit, e.target.value)}
                    className="param-modal-input"
                  />
                )}
              </label>
            </div>
          )}
        </div>
        
        {mode === 'edit' && (
          <div className="param-modal-footer">
            <button 
              className="param-modal-cancel" 
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              className="param-modal-save" 
              onClick={handleSave}
              disabled={loading}
            >
              {loading ? <i className="fas fa-spinner fa-spin"></i> : 'Save Changes'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ParamDetailModal;
